import { notifySuccess, notifyError } from "../components/Toast";
import {stepIds,fieldCategories} from "../enums/fieldsDataConfig";
import { tipoBonifComunidad } from "../config/bonificacionComunidad";
import { GetCarreras,GetCampusDisp,GetAnioCarrera,GetTurnosDisp,GetValor } from "./CarreraActions";


function transformData(rawData) {

  let stepPrograma = Object.values(rawData).find((step) => step.id === stepIds.PROGRAMA)?.responses;
  let stepPersona = Object.values(rawData).find((step) => step.id === stepIds.PERSONA)?.responses;
  let stepContacto = Object.values(rawData).find((step) => step.id === stepIds.CONTACTO)?.responses;
  let stepHomologacion = Object.values(rawData).find((step) => step.id === stepIds.HOMOLOGACION)?.responses;
  let stepEstudios = Object.values(rawData).find((step) => step.id === stepIds.ESTUDIOS)?.responses;
  let stepDatosAdicionales = Object.values(rawData).find((step) => step.id === stepIds.DATOS_ADICIONALES)?.responses;
  let stepFacturacion = Object.values(rawData).find((step) => step.id === stepIds.FACTURACION)?.responses;  


  let estudiante = {
    //persona
    nombre: stepPersona.nombres,
    apellido: stepPersona.apellidos,
    documentoNumero: stepPersona.documentoNumero,
    documentoTipo: stepPersona.documentoTipo,
    sexo: stepPersona.sexo,
    nacimiento: stepPersona.fechaNacimiento,
    estadoCivil: stepPersona.estadoCivil,
    paisOrigen: stepPersona.paisNacimiento,
    profesion: stepPersona.profesion,
    tipoAsistente: stepPersona.tipoAsistente,
    //contacto
    email: stepPersona.email,
    calle: stepContacto.calle,
    altura: stepContacto.altura,
    piso: stepContacto.piso,
    departamento: stepContacto.departamento,
    codPostal: stepContacto.codPostal,
    localidad: stepContacto.localidad,
    paisResidencia: stepContacto.paisResidencia,
    provincia: stepContacto.provincia,
    provinciaDescripcion: stepContacto.provinciaDescripcion,
    codAreaTelefono: stepContacto.codAreaParticular,
    telefono: stepContacto.telefonoParticular,
    codAreaCelular: stepPersona.codAreaCelular,
    celular: stepPersona.telefonoCelular,
    mailVerified: stepPersona.mailVerified,
    smsVerified: stepContacto.smsVerified,
    //datos adicionales
    tienePC: stepDatosAdicionales.tieneComputadora,
    utilizaPC: stepDatosAdicionales.utilizaComputadora,
    tieneInternet: stepDatosAdicionales.tieneInternet,
    sabeInformatica: stepDatosAdicionales.conocimientosInformatica
  };

  let estudiosSecundarios = null;
  let estudiosSuperior = null;
  let estudiosNoTerminados = null; 

  if (stepEstudios){

    estudiosSecundarios = {
      titulo: stepEstudios.tituloSecundario,
      cue: stepEstudios.cueSecundario,
      institucion: stepEstudios.institucionSecundaria,
      pais: stepEstudios.paisSecundario,
      provincia: stepEstudios.provinciaSecundario,
      provinciaDescripcion: stepEstudios.provinciaDescripcionSecundario,
      localidad: stepEstudios.localidadSecundaria,
      direccion: stepEstudios.direccionSecundaria,
      anioEgreso: stepEstudios.anioEgresoSecundario,
      promedio: stepEstudios.promedioSecundario,
    };

    estudiosSuperior = {
      tipoTitulo: stepEstudios.tipoTituloSuperior,
      titulo: stepEstudios.tituloSuperior,
      institucion: stepEstudios.institucionSuperior,
      pais: stepEstudios.paisSuperior,
      provincia: stepEstudios.provinciaSuperior,
      localidad:stepEstudios.localidadSuperior,
      provinciaDescripcion: stepEstudios.provinciaDescripcionSuperior,
      anioEgreso: stepEstudios.anioEgresoSuperior,
      promedio: stepEstudios.promedioSuperior,
    };

    estudiosNoTerminados = {
      nivelEstudio: stepEstudios.nivelEstudioNoCulminado,
      tipoTitulo: stepEstudios.tipoTituloNoCulminado,
      titulo: stepEstudios.tituloNoCulminado,
      institucion: stepEstudios.institucionNoCulminada,
      pais: stepEstudios.paisNoCulminado,
      provincia: stepEstudios.provinciaNoCulminado,
      provinciaDescripcion: stepEstudios.provinciaDescripcionNoCulminado,
      localidad: stepEstudios.localidadNoCulminada,
      anioInicio: stepEstudios.anioInicioNoCulminado,
      anioFin: stepEstudios.anioFinNoCulminado,
      promedio: stepEstudios.promedioNoCulminado,
    };
  }

  let facturacion = {
    tipo: stepFacturacion.tipoFacturacion,
    documentoTipo: stepFacturacion.tipoDocumento,
    documentoNumero: stepFacturacion.numeroDocumento,
    apellido: stepFacturacion.apellido,
    nombre: stepFacturacion.nombre,
    razonSocial: stepFacturacion.razonSocialEmpresa,
    descripcion: stepFacturacion.descripcionEmpresa,
    email: stepFacturacion.email,
    telefono: stepFacturacion.telefono,
    calle: stepFacturacion.calle,
    altura: stepFacturacion.altura,
    piso: stepFacturacion.piso,
    departamento: stepFacturacion.departamento,
    codigoPostal: stepFacturacion.codigoPostal,
    localidad: stepFacturacion.localidad,
    paisResidencia: stepFacturacion.paisResidencia,
    provincia: stepFacturacion.provincia,
    provinciaDescripcion: stepFacturacion.provinciaDescripcion,
    valorMatricula: stepFacturacion.valorMatricula,
  };


  let tutor = {
    //persona
    tipoTutor: stepPersona.tipoTutor,
    paisResidencia: stepPersona.paisResidenciaTutor,
    nombre: stepPersona.nombresTutor,
    apellido: stepPersona.apellidosTutor,
    documentoTipo: stepPersona.documentoTipoTutor,
    documentoNumero: stepPersona.documentoNumeroTutor,
    nacimiento: stepPersona.fechaNacimientoTutor,
  };

  // Determinar preinforme a enviar: solo si validado
  let preinformeToSend = null;
  if (stepHomologacion && stepHomologacion.estadoPreinforme === 'posee') {
    if (stepHomologacion.preinformeValid === true) {
      preinformeToSend = stepHomologacion.preinforme;
    } else {
      preinformeToSend = null;
    }
  }

  let solicitud = {
    //programa
    fechaingreso: stepPrograma.fechaIngreso,
    carrera: stepPrograma.carrera.split('-')[0].trim(),
    plan: stepPrograma.carrera.split('-')[1].trim(),
    campus: stepPrograma.campus,
    anioCursada: stepPrograma.anioCursada,
    turno: stepPrograma.turno,
    mailAcesor:stepPrograma.mailAcesor,
    descuentoId:stepPrograma.descuentoId,
    //contacto
    conocioInstitucion: stepContacto.conocioInstitucion,
    eligioInstitucion: stepContacto.eligioInstitucion,
    //homologacion
    solicitaPreinforme: stepHomologacion?.solicitaPreinforme,
    estadoPreinforme: stepHomologacion?.estadoPreinforme,
    preinforme: preinformeToSend,
    tipoSolicitudInsc: stepHomologacion?.catAlumno,
    declaracionEstudios: stepHomologacion?.declaracion,
    //datos adicionales
    estudioPadre: stepDatosAdicionales.estudiosPadre,
    estudioMadre: stepDatosAdicionales.estudiosMadre,
    trabaja: stepDatosAdicionales.trabaja,
    horasTrabajo: stepDatosAdicionales.horasTrabajo,

  };

  let data = {
    solicitud: [solicitud],
    estudiante: [estudiante],
    tutor: [tutor],
    facturacion: [facturacion],
    estudios_secundarios: [estudiosSecundarios],
    estudios_superiores: [estudiosSuperior],
    estudios_no_terminados: [estudiosNoTerminados]
  };

  return data;
}


export const SavePreRegistration = (data,t,navigate) => {
  return async (dispatch, getState) => {
    dispatch({ type: "SAVE_PREREGISTRATION_REQUEST" });
    try {
      let mappedData = transformData(data);
      mappedData = {...mappedData, programaTipo: t };

      // linksEventos: si la inscripción entró por un link cifrado válido, el "l" crudo viaja en el
      // payload para que NBAPI valide cupos y descuente uno al concretarse. Sin link → sin campo,
      // el payload queda idéntico al de siempre.
      const linkEvento = getState()?.respuestas?.linkEvento;
      if (linkEvento?.l && linkEvento?.data) {
        mappedData = { ...mappedData, linkEvento: linkEvento.l };
      }

      // El descuentoId sale del mismo slot de precio que gano en el summary
      // (comunidad si aplica, si no el normal): lo que se muestra, lo que se
      // cobra y lo que se registra en SIGUE quedan siempre consistentes.
      const summaryDescuentoId = getState()?.respuestas?.checkoutSummary?.descuentoId;
      if (summaryDescuentoId && mappedData.solicitud?.[0]) {
        mappedData.solicitud[0].descuentoId = summaryDescuentoId;
      }

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/pre-inscripcion`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(mappedData),
      });

      if (response.ok) {
        let respJson = null;
        try {
          respJson = await response.json();
        } catch (_) {
          respJson = null;
        }

        // Si corresponde, enviar mail de homologación usando el solicitudId devuelto
        try {
          const sol = mappedData?.solicitud?.[0] || {};
          const est = mappedData?.estudiante?.[0] || {};
          const solicitudId = respJson && respJson.solicitudId ? respJson.solicitudId : null;

          if (
            solicitudId &&
            sol.solicitaPreinforme === true &&
            sol.estadoPreinforme === 'solicita'
          ) {
            const urlMail = `${process.env.REACT_APP_API_BASE_URL}/checkout/homologacion/mail/enviar?carrera=${encodeURIComponent(sol.carrera)}&plan=${encodeURIComponent(sol.plan)}&email=${encodeURIComponent(est.email || '')}&nombre=${encodeURIComponent(est.nombre || '')}&apellido=${encodeURIComponent(est.apellido || '')}&solicitudId=${encodeURIComponent(solicitudId)}`;
            await fetch(urlMail, { method: 'GET' });
          }
        } catch (e) {
          // Silencioso: no afecta el flujo de preinscripción
        }

        dispatch({ type: "SAVE_PREREGISTRATION_SUCCESS" });
        navigate('/success');
        ResetResponse();
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "SAVE_PREREGISTRATION_FAIL", payload: errorMessage });
        throw new Error("Hubo un error al cargar su preinscripción.");
      }
    } catch (error) {
      dispatch({ type: "SAVE_PREREGISTRATION_FAIL", payload: error.message });
      notifyError(error.message);
      throw error;
    }
  };
};

/*export const SaveResponse = (step, field, value) => ({
  type: 'SAVE_RESPONSE',
  payload: { step, field, value },
});*/

export const SaveResponses = (stepId, responses) => ({
  type: 'SAVE_RESPONSES',
  payload: { stepId, responses },
});

export const SetBonus = (bonus) => ({
  type: 'SET_BONUS',
  payload: { bonus },
});

export const setCheckoutSummary = ({
  carrera,
  fechaIngreso,
  campus,
  turno,
  precioOriginal,
  precioDescuento,
  precioComunidad,
  descuentoVencimiento,
  descuentoPorcentaje,
  descuentoId,
}) => (dispatch) => {
  
  if (!carrera || !fechaIngreso || !campus || !turno) {
    dispatch({
      type: 'SET_CHECKOUT_SUMMARY_FAIL',
      payload: 'Faltan datos obligatorios para el resumen de inscripción.',
    });
    return;
  }
  if (precioOriginal <= 0) {
    dispatch({
      type: 'SET_CHECKOUT_SUMMARY_FAIL',
      payload: 'El valor de precio no es válido.',
    });
    return;
  }

  const summary = {
    carrera,
    fechaIngreso,
    campus,
    turno,
    precioOriginal,
    precioDescuento,
    precioComunidad,
    descuentoVencimiento,
    descuentoPorcentaje,
    descuentoId,
  };

  dispatch({
    type: 'SET_CHECKOUT_SUMMARY',
    payload: summary,
  });
};

export const setActiveStep = (step) => ({
  type: 'SET_ACTIVE_STEP',
  payload: step,
});

export const clearSteps = () => ({
  type: 'CLEAR_STEPS',
});

export const setStepId = (stepNumber, id) => ({
  type: 'SET_STEP_ID',
  payload: { stepNumber, id },
});

export const ResetResponse = () => ({
  type: 'RESET_RESPONSES',
});

export const GetVerificarHomologacion = (carrera, plan, tipodoc, numerodoc, email, nro_preinforme) => {
  return async (dispatch) => {
    dispatch({ type: "VERIFICAR_HOMOLOGACION_REQUEST" });

    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/checkout/validacion/homologacion?carrera=${carrera}&plan=${plan}&tipodoc=${tipodoc}&numerodoc=${numerodoc}&email=${email}&nro_preinforme=${nro_preinforme}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const isValid = await response.json();
        dispatch({ type: "VERIFICAR_HOMOLOGACION_SUCCESS", payload: isValid });
        // Persistimos en las respuestas del paso HOMOLOGACION si es válido o no
        dispatch(SaveResponses(stepIds.HOMOLOGACION, { preinformeValid: isValid }));

        if (isValid) {
          notifySuccess("Preinforme válido");
        } else {
          notifyError("Preinforme inválido");
        }
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "VERIFICAR_HOMOLOGACION_FAIL", payload: errorMessage });
        notifyError("Error al validar el preinforme");
      }
    } catch (error) {
      dispatch({ type: "VERIFICAR_HOMOLOGACION_FAIL", payload: error.message });
      notifyError("Error de conexión al validar el preinforme");
    }
  };
};

export const GetKnownUser = (token, t) => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_CONOCIOUSUARIO_REQUEST" });
    // Precios de una visita anterior no aplican a este token.
    dispatch({ type: "CLEAR_VALOR" });

    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/checkout/user/validation`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify( token ),
      });

      if (response.ok) {
        const data = await response.json();

        const [cod, plan] = data[0]["carrera"]?.split("-");
        const fechaIngreso = data[0]["fechaIngreso"];

        const [year, month, day] = fechaIngreso?.split('-');
        const periodo = month >= 1 && month <= 7 ? 0 : 1; 

        dispatch(setActiveStep(1));

        dispatch(GetCarreras(cod,periodo,t));
        dispatch(GetCampusDisp(year, cod, plan,periodo));
        dispatch(GetAnioCarrera(cod, plan));
        dispatch(GetTurnosDisp(year, cod, plan, data[0]["anioCursada"], data[0]["campus"],periodo));
        
        
        // Primera llamada: tipoBonificacion = null (precio publico vigente)
        dispatch(GetValor(year, cod, plan, data[0]["anioCursada"], data[0]["campus"], data[0]["turno"], "EFECTIVO",data[0]["fechaIngreso"],"externo"));

        // Segunda llamada: precio comunidad, SOLO si este tipo de programa tiene
        // bonificacion de comunidad configurada en SIGUE (hoy: solo micro).
        const bonifComunidad = tipoBonifComunidad(t);
        if (bonifComunidad) {
          setTimeout(() => {
            dispatch(GetValor(year, cod, plan, data[0]["anioCursada"], data[0]["campus"], data[0]["turno"], "EFECTIVO",data[0]["fechaIngreso"],"externo",bonifComunidad));
          }, 1000);
        }


       const parseDate = (dateStr) => {
          if (!dateStr) return null;
          // Si la fecha viene en formato DD/MM/YYYY
          if (typeof dateStr === 'string' && dateStr.includes('/')) {
            const [day, month, year] = dateStr.split('/');
            return new Date(year, month - 1, day);
          }
          return new Date(dateStr);
        };

        const stepUserData = {
          //persona
          nombres: data[0].Nombre,
          apellidos: data[0].Apellido,
          documentoNumero: data[0]["Nro Doc"],
          documentoTipo: data[0]["Tipo Doc"],
          sexo: data[0].Sexo,
          nacionalidad: data[0]["País origen"],
          fechaNacimiento: parseDate(data[0].Nacimiento),
          estadoCivil: data[0].EstadoCivil,
          paisNacimiento: data[0]["País origen"],
          profesion: data[0].Profesión,
          tipoAsistente: "alumnouai",
          // El mail ya esta verificado: el link con token llego a esta casilla
          // registrada. El campo email vive en el paso PERSONA (PersonalDataForm),
          // por eso se guarda aca y no en CONTACTO.
          email: data[0]["mail"],
          emailConfirmacion: data[0]["mail"],
          mailVerified: true,
          telefonoCelular: data[0]["Celular"] || '',
          //tutor
          tipoTutor: data[0].tipoTutor || null,
          paisResidenciaTutor: data[0].paisResidenciaTutor || null,
          nombresTutor: data[0].nombresTutor || '',
          apellidosTutor: data[0].apellidosTutor || '',
          documentoTipoTutor: data[0].documentoTipoTutor || null,
          documentoNumeroTutor: data[0].documentoNumeroTutor || '',
          fechaNacimientoTutor: parseDate(data[0].fechaNacimientoTutor),
        };
       // dispatch({ type: "LOAD_CONOCIOUSUARIO_SUCCESS", payload:stepUserData });
       dispatch(SaveResponses(stepIds.PERSONA,stepUserData));
       const stepContactData={
        calle: data[0]["Calle"],
        altura: data[0]["Altura"],
        piso: data[0]["Piso"],
        departamento: data[0]["Dpto"],
        codPostal: data[0]["Cod Postal"],
        localidad: data[0]["Localidad"],
        paisResidencia: data[0]["Pais Residencia"],
        provincia: data[0]["Provincia"],
        provinciaDescripcion: data[0]["Provincia Desc"],
       };
       dispatch(SaveResponses(stepIds.CONTACTO,stepContactData));

       const stepProgramaData={
        fechaIngreso: data[0]["fechaIngreso"],
        carrera: data[0]["carrera"],
        campus: data[0]["campus"],
        turno: data[0]["turno"],
        anioCursada: data[0]["anioCursada"],
       };
       dispatch(SaveResponses(stepIds.PROGRAMA,stepProgramaData));
       dispatch({ type: "LOAD_CONOCIOUSUARIO_SUCCESS" });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_CONOCIOUSUARIO_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar los datos del usuario.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_CONOCIOUSUARIO_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar los datos del usuario.");
    }
  };
};
